import React from 'react';
import PhoneInput from 'react-phone-input-2';
import { makeStyles } from '@material-ui/core/styles';
import 'react-phone-input-2/lib/material.css';

// Match MUI TextField outlined size="small" height (40px)
const INPUT_HEIGHT = 40;

const useStyles = makeStyles((theme) => ({
  error: {
    '& .react-tel-input, & .react-tel-input:hover': {
      borderColor: `${theme.palette.error.main} !important`,
    },
    '& .react-tel-input .special-label': {
      color: theme.palette.error.main,
    },
  },
  helper: {
    margin: '3px 14px 0',
    fontSize: '0.75rem',
    lineHeight: 1.66,
    color: theme.palette.error.main,
  },
  wrapper: {
    '& .react-tel-input': {
      border: `1px solid ${theme.palette.grey[400]}`,
      borderRadius: 10,
      minHeight: INPUT_HEIGHT,
      '&:hover': {
        borderColor: theme.palette.text.primary,
      },
      '&:focus-within': {
        borderColor: theme.palette.primary.main,
        borderWidth: 2,
        margin: -1,
        '& .form-control + div:before': {
          color: theme.palette.primary.main,
        },
        '& .flag-dropdown': {
          borderRightColor: theme.palette.primary.main + ' !important',
        },
      },
    },
    '& .form-control': {
      border: 'none !important',
      borderRadius: '0 10px 10px 0 !important',
      height: `${INPUT_HEIGHT - 2}px !important`,
      minHeight: 'auto !important',
      padding: `0 14px 0 58px !important`,
      fontSize: '14px !important',
      '&:focus': {
        boxShadow: 'none !important',
        outline: 'none',
      },
    },
    '& .flag-dropdown': {
      border: 'none !important',
      borderRight: `1px solid ${theme.palette.grey[400]} !important`,
      borderRadius: '10px 0 0 10px !important',
      minHeight: INPUT_HEIGHT - 2,
    },
    '& .selected-flag': {
      minHeight: INPUT_HEIGHT - 2,
    },
  },
}));

export const DEFAULT_PHONE_COUNTRY = 'za';

const PhoneInputField = ({
  value,
  handleChange,
  label = 'Phone',
  required = true,
  country = DEFAULT_PHONE_COUNTRY,
  error = false,
  helperText,
}) => {
  const classes = useStyles();

  return (
    <div className={`${classes.wrapper}${error ? ` ${classes.error}` : ''}`}>
      <PhoneInput
        country={country}
        preferredCountries={[DEFAULT_PHONE_COUNTRY]}
        enableSearch
        value={value}
        onChange={handleChange}
        specialLabel={label}
        inputProps={{
          name: 'phone',
          required,
        }}
        containerStyle={{
          width: '100%',
        }}
        inputStyle={{
          width: '100%',
        }}
      />
      {helperText ? <p className={`${classes.helper}${error ? ' Mui-error' : ''}`}>{helperText}</p> : null}
    </div>
  );
};

export default PhoneInputField;